import { Box, Button, Container, Divider, Typography } from "@mui/material";
import React from "react";
import SwiperCore, { Autoplay, Pagination, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useAPI } from "../../../../apiContext";
SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);

const Books = () => {
	const { data } = useAPI();

	return (
		<Container sx={{ pt: 5, "& .swiper-slide": { height: "auto" } }}>
			<Box
				sx={{ border: "3px solid", borderRadius: "15px", p: 1 }}
				className='borderColor'>
				{data?._id && data?.headline?.Books ? (
					<>
						{data?.headline?.Books === "off" ? (
							""
						) : (
							<>
								<Typography
									className='textColor'
									sx={{ mb: 0.5, fontWeight: 900 }}
									variant='h4'
									component='div'
									gutterBottom>
									{data?.headline?.Books}
									<Divider className={`${data?.color?.hr}`} />
								</Typography>
								{data?.Books?.length > 0 ? (
									<Swiper
										effect={"coverflow"}
										autoHeight={true}
										grabCursor={true}
										loop={true}
										autoplay={{ delay: 2500 }}
										centeredSlides={true}
										slidesPerView={"auto"}
										initialSlide={1}
										coverflowEffect={{
											rotate: 50,
											stretch: 0,
											depth: 100,
											modifier: 1,
											slideShadows: false,
										}}
										pagination={true}>
										{data?.Books?.map((a, key) => (
											<SwiperSlide
												key={key}
												style={{ position: "relative", cursor: "pointer" }}>
												<img
													src={a?.imageLink2}
													alt=''
													style={{ borderRadius: 7 }}
												/>
												<Typography
													className='textColor'
													sx={{ fontWeight: 900, my: 0.5 }}
													variant='h5'
													component='div'>
													{a?.galleryTitle}
												</Typography>
												<Button
													onClick={() => window.open(`${a?.link}`, "_blank")}
													className='button'
													variant='contained'
													sx={{
														width: "100%",
														fontWeight: "bold",
														borderRadius: "11px",
														border: "1px solid",
														mb: -2,
													}}>
													{a?.buttonTitle}
												</Button>
											</SwiperSlide>
										))}
									</Swiper>
								) : (
									<Typography
										className='textColor'
										sx={{ mb: 0.5, fontWeight: 900 }}
										variant='h6'
										component='div'
										gutterBottom>
										No Books !...
									</Typography>
								)}
							</>
						)}
					</>
				) : (
					<div className='loader'>
						<PropagateLoader size={11} />
					</div>
				)}
			</Box>
		</Container>
	);
};

export default Books;
